export const IS_DEV = process.env.REACT_APP_MOBILE_API_URL?.includes('dev.radioking.xyz');
export const IS_STG = process.env.REACT_APP_MOBILE_API_URL?.includes('rc.radioking.com');
export const IS_PROD = process.env.REACT_APP_MOBILE_API_URL?.includes('radioking.com');
